<app-panel-hub [config]="panelHubConfig" (panelHubStateChanged)="onPanelHubStateChanged($event)"
    *ngIf="config.skillCode"
    [pagedData]="pagedData" (panelEventHub)="onPanelEventHubInitialized($event)" class="skill-training-items-panel">
    
    <!-- Content Template - Training Item details display -->
    <ng-template #contentTemplate let-data="dataVar">
        <div panel-content>
            <div class="grid">
                <div class="col-5 m-0 trainingItemOverflow">
                    <div class="grid m-0">
                        <div class="col flex-initial trainingItemOverflow pl-1">
                            <app-label labelText="Training Item"></app-label>
                            <div *ngIf="data?.trainingItemType == 1">
                                <a class="overflow-ellipse flex-initial flex underline text-primary"
                                    style="cursor: pointer;" (click)="openDocument(data?.trainingItemId, data?.version)">
                                    <app-read-only
                                        readonlyText="{{ data?.trainingItemId }} {{data?.title}} (v{{ data?.version }})"
                                        toolTipMessage="{{ data?.trainingItemId }} {{data?.title}} (v{{ data?.version }})"></app-read-only>
                                </a>
                            </div>
                            <div *ngIf="data?.trainingItemType == 2">
                                <a class="overflow-ellipse flex-initial flex underline text-primary"
                                    style="cursor: pointer;" (click)="openCourse(data?.trainingItemId)">
                                    <app-read-only readonlyText="{{ data?.trainingItemId }} {{data?.title}}"
                                        toolTipMessage="{{ data?.trainingItemId }} {{data?.title}}"></app-read-only>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-2 trainingItemOverflow text-left">
                    <app-label labelText="Type"></app-label>
                    <app-read-only readonlyText="{{ data?.typeName }}"></app-read-only>
                </div>
                <div class="col-2 trainingItemOverflow text-left">
                    <app-label labelText="Training Item Group"></app-label>
                    <ng-container *ngIf="data?.trainingItemGroups?.length; else noTrainingItemGroup">
                        <div class="content-wrap" *ngFor="let tig of data?.trainingItemGroups">
                            <app-read-only readonlyText="{{ tig }}"></app-read-only>
                        </div>
                    </ng-container>
                    <ng-template #noTrainingItemGroup>
                        <app-read-only [readonlyText]="noTrainingItemGroupText"></app-read-only>
                    </ng-template>
                </div>
                <div class="col text-left">
                    <app-label labelText="Status"></app-label>
                    <div class="grid">
                        <div class="col max-w-0">
                            <em class="pi pi-circle-fill" [ngClass]="{
                    active: data?.status == 1,
                    inactive: data?.status == 2
                    }"></em>
                        </div>
                        <div class="col ml-1 pl-3">
                            <app-read-only readonlyText="{{ data?.statusName }}"></app-read-only>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</app-panel-hub>

<div class="button-container" *ngIf="config.skillCode">
    <p-splitButton class="p-splitbutton-menubutton splitBtn status" label="Status" [model]="statusItems" [disabled]="isStatusButtonDisabled"></p-splitButton>
    <p-button
        *ngIf="config.isUnassignTrainingItemGroupVisible"
        appPreventDoubleClick
        label="Un-Assign Training Item Group"
        type="submit"
        id="unassignTrainingItemGroupButton"
        (debounceClick)="requestUnassignTrainingItemGroup()"
    ></p-button>
</div>

